<template>
    <div class="ser-type">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/service/service' }">服务商管理</el-breadcrumb-item>
                <el-breadcrumb-item>服务商类型添加</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增服务商类型</h2>
                <div class="item" @click="toList"><i class="icon el-icon-arrow-left" type="primary"></i>服务商列表</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="add-box bg_fff p20" style="text-align: left">
                <el-button type="primary" @click="addType">新增类型</el-button>
                <div class="table-box" style="margin-top: 20px">
                    <el-table
                            :data="typeList"
                            style="width: 100%;margin-bottom: 20px;"
                            row-key="cate_id"
                            border
                            default-expand-all
                            :tree-props="{children: 'child', hasChildren: 'hasChild'}">
                        <el-table-column
                                prop="cate_name"
                                label="类型名称"
                                sortable
                                >
                        </el-table-column>
                        <el-table-column
                                prop="cate_name"
                                label="类型图标"
                                sortable
                        >
                            <template slot-scope="scope">
                                <span v-if="!scope.row.cover">暂无图标</span>
                                <img v-else :src="scope.row.cover|handleImg" alt="" style="width: 80px;height: 80px;">
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="role_id!=4||(role_id==4&&hasUpdate)" type="text" size="small"  @click="updateRow(scope.row,scope.$index)">修改</el-button>
                                <el-button v-if="role_id!=4||(role_id==4&&hasDel)" type="text" size="small" @click="deleRow(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog
            :title="(edit?'更新':'新增')+'分类'"
            :visible.sync="dialogVisible"
            width="600px">
                <el-form ref="form"  :model="form" label-width="100px" align="left" >
                    <el-form-item label="所属大类" prop="fid" style="width: 550px;" v-if="serviceType==2">
                        <div class="d_flex">
                            <el-select v-model="cate_id" filterable clearable placeholder="输入服务商大类关键字">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.cate_id"
                                        :label="item.cate_name"
                                        :value="item.cate_id"
                                >
                                </el-option>
                            </el-select>
                            <span style="margin-left: 10px;font-size: 12px;color: #f00;">不选择为添加服务商大类</span>
                        </div>
                    </el-form-item>
                    <el-form-item :label="(id?'':'小类')+'名称'" prop="username" style="width: 350px;">
                        <el-input v-model="form.cate_name" autocomplete="off"  placeholder="请输入类型名称"></el-input>
                    </el-form-item>
                    <el-form-item  label="图标" style="width: 100%;" prop="fileList" v-if="serviceType==2">
                        <div class="d_flex">
                            <div class="upload-img-box d_flex" v-if="rulesForm.fileList.length>0">
                                <div class="img" v-for="(item,index) in rulesForm.fileList">
                                    <img :src="item|handleImg" @click="previewIMg(item)" alt="">
                                    <i class="el-icon-error" @click="deleteImg(1,index)"></i>
                                </div>
                            </div>
                            <el-upload class="avatar-uploader"
                                       ref="otherLicense"
                                       :auto-upload="false"
                                       action
                                       :multiple="true"
                                       :on-preview="handlePicPreview"
                                       :on-remove="handleRemove"
                                       :file-list="rulesForm.fileList"
                                       :on-change="otherSectionFile"
                                       list-type="picture-card"
                                       v-if="rulesForm.fileList.length<1"
                            >
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">{{edit?'立即修改':'立即添加'}}</el-button>
                        <el-button  @click="cancelUpdate">取消</el-button>
                    </el-form-item>
                </el-form>
        </el-dialog>
        <el-dialog
                title="删除分类"
                :visible.sync="delPop"
                width="500px"
                style="text-align: left"
        >
            <div class="pop-box">
                 <p style="color: #f00;text-align: center;margin-bottom: 20px;">您确认删除此分类吗？</p>
                <p style="color: #3a8ee6;">仅删除分类保留子类请选择接受转移的类型，不选择默认直接删除</p>
                <el-select v-model="update_cate_id" filterable clearable placeholder="输入服务商大类关键字" style="margin: 20px;width: 300px;">
                    <el-option
                            v-for="item in typeList"
                            :key="item.cate_id"
                            :label="item.cate_name"
                            :value="item.cate_id"
                    >
                    </el-option>
                </el-select>

                <div class="btn-box" style="text-align: right">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="subBtn">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {servicecateSave, serviceTypeList,delType} from '../../api/service'
    import {mapState} from "vuex";
    export default {
        name: "type",
        data(){
            return{
                dialogVisible:false,
                typeList:[],
                cate_id:'',
                form:{
                    cate_name:'',
                    status:1,
                    fid:0,
                },
                rulesForm:{
                    fileList:[],
                },
                delPop:false,
                curData:'',
                update_cate_id:'',
                id:'',
                role_id:'',
                serviceType:'',
                edit:false,
            }
        },
        mounted() {
            this.serviceTypeList();
            this.role_id=localStorage.getItem('ROLE');
        },
        computed:{
            ...mapState(['baseUrl','cityArr'])
        },
        methods:{
            addType(){
                this.edit=false;
                this.form={
                    cate_name:'',
                    status:1,
                    fid:0,
                };
                this.rulesForm.fileList=[];
                this.serviceType=2;
                this.dialogVisible=true;
            },
            serviceTypeList(){
                serviceTypeList().then(res=>{
                    if(res.code==1){
                        this.typeList=res.data;
                    }
                })
            },
            onSubmit(){
                if(!this.form.cate_name){
                    this.$message.error('请输入类型名称');
                    return;
                }
                if(this.edit){
                    if(this.form.fid!=0){
                        this.form.fid=this.cate_id;
                        if(this.rulesForm.fileList.length==0&&this.serviceType==2){
                            this.$message.error('请选择类型图标');
                            return;
                        }
                        this.form.cover=this.rulesForm.fileList[0];
                    }
                }else{
                    if(this.cate_id){
                        this.form.fid=this.cate_id;
                        if(this.rulesForm.fileList.length==0&&this.serviceType==2){
                            this.$message.error('请选择类型图标');
                            return;
                        }
                        this.form.cover=this.rulesForm.fileList[0];
                    }
                    if(this.id){
                        this.form.cate_id=this.id;
                    }
                }

                servicecateSave(this.form).then(res=>{
                    if(res.code==1){
                        if(this.edit){
                            this.$message.success('修改成功');
                        }else{
                            this.$message.success('添加成功');
                        }
                        this.dialogVisible=false;
                        this.cate_id='';
                        this.form={
                            cate_name:'',
                            status:1,
                            fid:0,
                        };
                        this.id='';
                        this.serviceTypeList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            toList(){
                this.$router.push({path: '/service/service'});
            },
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.rulesForm.fileList.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.rulesForm.fileList.push(res.data.data.path);
                    }
                })
            },
            deleteImg(){
                this.rulesForm.fileList=[];
            },
            deleRow(row){
                this.curData=row;
                this.delPop=true;
            },
            updateRow(row,index){
                this.edit=true;
                console.log(row);
                if(row.fid==0){
                    this.serviceType=1;
                    this.cate_id=row.cate_id;
                }else{
                    this.serviceType=2;
                    this.cate_id=row.fid;
                }
                this.form.cate_name=row.cate_name;
                this.form.cate_id=row.cate_id;
                if(row.cover){
                    this.rulesForm.fileList=[row.cover];
                }
                this.form.fid=row.fid;
                this.dialogVisible=true;
            },
            cancel(){
                this.curData='';
                this.delPop=false;
                this.rulesForm.fileList=[];
            },
            cancelUpdate(){
                this.dialogVisible=false;
                this.cate_id='';
                this.form={
                    cate_name:'',
                    status:1,
                    fid:0,
                };
                this.rulesForm.fileList=[];
                this.id='';
            },
            subBtn(){
                delType({
                    cate_id:this.curData.cate_id,
                    new_cate_id:this.update_cate_id||''
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.serviceTypeList();
                        this.delPop=false;
                        this.rulesForm.fileList=[];
                        this.cate_id='';
                        this.form={
                            cate_name:'',
                            status:1,
                            fid:0,
                        };
                        this.update_cate_id='';
                        this.id='';
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            previewIMg(img){
                this.imgPop=true;
                if(img.indexOf('http')!=-1){
                    this.preImg=img;
                }else{
                    this.preImg=this.baseUrl+img;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .upload-img-box{
        width: 100%;
    .img{
        width: 146px;
        height: 146px;
        border-radius: 4px;
        margin-right: 10px;
        position: relative;
    i{
        position: absolute;
        top: -5px;
        font-size: 24px;
        color: #f00;
    }
    .el-icon-error{
        right: -5px;
    }
    img{
        width: 146px;
        height: 146px;
        border-radius: 4px;
    }
    }
    }
</style>
